import { render, staticRenderFns } from "./huddle_panel.vue?vue&type=template&id=3aee853e&scoped=true&"
import script from "./huddle_panel.vue?vue&type=script&lang=js&"
export * from "./huddle_panel.vue?vue&type=script&lang=js&"
import style0 from "./huddle_panel.vue?vue&type=style&index=0&id=3aee853e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aee853e",
  null
  
)

export default component.exports